import { memo, useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useStore } from 'store/StoreContext';
import { callLogoutApi } from 'requests/RequestLogin';
import { News, callGetNewsApi } from 'requests/RequestNews';
import { RoutePath } from 'consts/RoutePath';
import { clearGenerator } from 'store/login-user/LoginUserData';
import { saveGenerator } from 'store/service-prohibition/ServiceProhibitionData';
import { formatDate, NEWS_DATE } from 'common/dateFormatter';
import { CircularProgress, Backdrop } from '@material-ui/core';
import classes from './override.module.scss';
import { HttpStatus } from 'consts/HttpStatus';
import { unescapeHtml } from 'common/HtmlEscaper';
import { Menu } from 'components/organisms/menu/Menu';
import { ServiceLogoList } from 'components/molecules/service-logo-list/ServiceLogoList';
import { SERVICE_LIST } from 'utils/constants';

type Props = {};

export type ServiceList = {
	serviceName: string;
	url: string;
	logoPath: string;
	textMessage: string;
};

export const MyPageTemplate = memo((_props: Props) => {
	const history = useHistory();
	const [store, dispatch] = useStore(); // eslint-disable-line

	// お知らせ一覧を取得する
	const [newsLoading, setNewsLoading] = useState(false);
	const [newsData, setNewsData] = useState<News[]>([]);
	useEffect(() => {
		const execute = async () => {
			setNewsLoading(true);
			const [getNewsResult, _] = await Promise.all([callGetNewsApi(), saveGenerator(dispatch)]);
			if (getNewsResult.status !== HttpStatus.OK && !getNewsResult.data) {
				setNewsLoading(false);
				history.push(RoutePath.ERROR);
				return;
			}
			setNewsData(getNewsResult.data.news_list);
			setNewsLoading(false);
		};
		execute();
	}, []);

	const [logoutLoading, setLogoutLoading] = useState(false);
	const logout = async () => {
		setLogoutLoading(true);
		const logoutResult = await callLogoutApi();
		if (logoutResult.status !== HttpStatus.OK) {
			setLogoutLoading(false);
			history.push(RoutePath.ERROR);
			return;
		}
		setLogoutLoading(false);
		clearGenerator(dispatch);
		history.push(RoutePath.LOGIN);
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenIDマイページ';
	}, []);

	return (
		<main>
			<Backdrop className={classes.backdrop} open={newsLoading || logoutLoading}>
				<CircularProgress color="inherit" />
			</Backdrop>
			<section className="section mypage" ref={scrollRef}>
				<div className="breadcrumb" style={{ marginBottom: '18px' }}>
					<ul>
						<li>マイページTOP</li>
					</ul>
				</div>

				<div className={classes.familyAnnounce}>
					<span className={classes.familyAnnounceTitle}>GakkenID会員の皆様へ</span>
					<br />
					<span>
						マイページより「家族」の作成、および、GakkenこどもIDが登録できるようになりました。詳しくは
						<a href="/faq.html" target="_blank">
							コチラ
						</a>
						をご確認ください。
					</span>
				</div>

				<h2 className="page-head">マイページ</h2>
				<section className={`service ${classes.mypageServiceSection}`}>
					<h3 className={classes.secondTitle}>手続きメニュー</h3>
					<Menu />
				</section>

				<section className={`news ${classes.mypageNewsSection}`}>
					<h3 className={classes.secondTitle}>GakkenIDからのお知らせ</h3>
					<div className="news-box">
						<ul>
							{newsData.map((n) => {
								return (
									<li>
										<span>{formatDate(new Date(n.start_date), NEWS_DATE)}</span>
										{/* お知らせタイトルにHTMLタグ情報も含まれているためdangerouslySetを使用 */}
										<div dangerouslySetInnerHTML={{ __html: unescapeHtml(n.title) }} />
									</li>
								);
							})}
						</ul>
					</div>
				</section>

				<section className={`service ${classes.mypageServiceSection}`}>
					<h3 className={classes.secondTitle}>ご利用可能なサービス一覧</h3>
					<ServiceLogoList serviceList={SERVICE_LIST} />
				</section>

				<div className="btn-box">
					<div className="btn logout">
						<button onClick={logout}>
							<span>ログアウト</span>
						</button>
					</div>
				</div>
			</section>
		</main>
	);
});
